import React from "react";

// A game's result as a small pill on the basketball performance cards (the
// athlete profile's Game by Game, the coach team page's Game Log), in the
// colour roles the game bars use (spec B18): a team win in bm-orange, a
// loss grey, a tie passive. The letter, and the score when there is one,
// is for the eye; screen readers hear the word ("Win 85-77"). A game with
// no final result gets no pill: the caller shows its own placeholder.
//
//   ResultPill({ result: "W" | "L" | "T", score, className })
//   RESULT_WORDS  { W: "Win", L: "Loss", T: "Tie" }

const cx = (...parts) => parts.filter(Boolean).join(" ");

export const RESULT_WORDS = { W: "Win", L: "Loss", T: "Tie" };

const TONES = {
  W: "bg-bm-orange text-white",
  L: "bg-bm-mutedbg text-bm-muted",
  T: "bg-bm-border text-bm-ink",
};

export const ResultPill = ({ result, score, className = "" }) => {
  const word = RESULT_WORDS[result];
  if (!word) return null;
  const tail = score ? ` ${score}` : "";
  return (
    <span
      className={cx(
        "inline-flex h-[22px] min-w-[22px] shrink-0 items-center justify-center whitespace-nowrap rounded-full bm-label-xs tabular-nums",
        tail ? "px-2" : "px-[6px]",
        TONES[result],
        className,
      )}
    >
      <span aria-hidden="true">{`${result}${tail}`}</span>
      <span className="sr-only">{`${word}${tail}`}</span>
    </span>
  );
};

export default ResultPill;
